import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} - 91动漫`}
          title={`${item.title} - 91动漫`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-secondary-950/80 px-2.5 py-1 text-xs font-medium text-white backdrop-blur-sm">
          {item.tags[0]}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">{item.summary}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line text-sm" />
            {item.date}
          </span>
          <span className="flex items-center gap-1 text-primary-600">
            阅读全文
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </div>
      </div>
    </Link>
  );
}